/**
 * A handful of leaves drift down once when a page opens, then disappear.
 * Never continuous (DESIGN.md: "never falling leaves across a whole page").
 * Skipped entirely under `prefers-reduced-motion`.
 */
import './ui.css';

const LEAF_COLOURS = ['#8fcf6a', '#4f7a4e', '#f2c14e', '#b6e29b', '#e07a3f'];

function leafSvg(colour: string): string {
  return `<svg viewBox="0 0 40 40" aria-hidden="true"><path d="M20 3 C33 9 36 25 20 37 C4 25 7 9 20 3Z" fill="${colour}" stroke="#1f3b2d" stroke-width="2" stroke-linejoin="round"/><path d="M20 8 V34 M20 18 L27 13 M20 25 L13 20" fill="none" stroke="#1f3b2d" stroke-width="1.6" stroke-linecap="round"/></svg>`;
}

export function dropLeaves(count = 7): void {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  const layer = document.createElement('div');
  layer.className = 'leaf-layer';
  layer.setAttribute('aria-hidden', 'true');
  for (let i = 0; i < count; i++) {
    const leaf = document.createElement('div');
    leaf.className = 'leaf';
    const size = 18 + Math.random() * 18;
    // At the far edges, so headlines, cards and end texts stay readable (U16).
    const side = Math.random() * 8;
    leaf.style.left = `calc(${String(i % 2 === 0 ? 1 + side : 91 + side)}vw - ${String(i % 2 === 0 ? 0 : size)}px)`;
    leaf.style.width = `${String(size)}px`;
    leaf.style.animationDelay = `${String(Math.random() * 1.2)}s`;
    leaf.style.animationDuration = `${String(2.2 + Math.random() * 1.4)}s`;
    leaf.style.setProperty('--sway', `${String(-25 + Math.random() * 50)}px`);
    leaf.style.setProperty('--spin', `${String(-200 + Math.random() * 400)}deg`);
    leaf.innerHTML = leafSvg(LEAF_COLOURS[i % LEAF_COLOURS.length] ?? '#8fcf6a');
    layer.append(leaf);
  }
  document.body.append(layer);
  window.setTimeout(() => {
    layer.remove();
  }, 5000);
}
